import { isNumber } from 'lodash-es'

/**
 * Converte valor monetário para número (float em reais).
 * Aceita number, string pt-BR (1.234,56) ou string/uso de ponto decimal (1234.56).
 */
export const parseMoneyToNumber = money => {
  if (money === null || money === undefined || money === '') {
    return 0
  }
  if (isNumber(money)) {
    return Number.isFinite(money) ? money : 0
  }

  const s = String(money)
    .trim()
    // Remove prefixos/símbolos (ex.: "R$ ") e mantém apenas caracteres numéricos relevantes.
    .replace(/[^\d,.-]/g, '')
    // Permite sinal negativo apenas na primeira posição.
    .replace(/(?!^)-/g, '')
  if (!s) {
    return 0
  }

  const lastComma = s.lastIndexOf(',')
  const lastDot = s.lastIndexOf('.')

  // pt-BR: milhar com ponto e centavos com vírgula (ex.: 40.523,83)
  if (lastComma > lastDot) {
    const normalized = s.replace(/\./g, '').replace(',', '.')
    const n = Number(normalized)
    return Number.isFinite(n) ? n : 0
  }

  // ISO / US: ponto decimal (ex.: 40523.83); vírgulas podem ser milhar
  if (lastDot > lastComma) {
    const n = Number(s.replace(/,/g, ''))
    return Number.isFinite(n) ? n : 0
  }

  const digitsOnly = s.replace(/\D/g, '')
  const n = Number(digitsOnly)
  return Number.isFinite(n) ? n : 0
}

export const parseNumberToMoney = number => {
  const value =
    isNumber(number) && Number.isFinite(number)
      ? number
      : parseMoneyToNumber(number)
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
  return formatter.format(Number.isFinite(value) ? value : 0)
}
